/*
 * Copyright (c) 2023, tuanchauict
 */

package mono.common

val <T> T.exhaustive: T
    get() = this
